import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { SidePanel } from '@alfa-bank/newclick-composite-components/side-panel';
import { openSidePanel } from '@alfa-bank/newclick-core/window-utils';
import cn from 'classnames';
import { voipScreens } from '../../constants/types';
import { useVoipContext } from '../../hooks/use-voip-context';
import { useWebview } from '../../hooks/use-webview';
import { useWidgetContext } from '../../hooks/use-widget-context';
import { Page } from '../../types/constants';
import { CollapsedDisabledLayout } from '../collapsed-disabled-layout';
import { CollapsedVoip } from '../collapsed-voip';
import { WebviewLayout } from '../webview-layout';
import styles from './index.module.css';
export const PanelWrapper = ({ open, onClose, background, children }) => {
    const { isWebview } = useWebview();
    const { phone, remoteAudioVideo, setVoipScreen, voipScreen, accessMicroStatus, haveDevices, clearMicroStates, } = useVoipContext();
    const { collapsedCall, displayPanel, setCollapsedCall, theme, collapsedDisable } = useWidgetContext();
    const isWithCallScreen = voipScreen === voipScreens.WITH_CALL;
    const handleCloseAnimationEnd = () => {
        if (accessMicroStatus === 'DENIED' || haveDevices === 'NOT_MICRO') {
            clearMicroStates();
        }
    };
    const sidePanelTransitionProps = {
        onExited: handleCloseAnimationEnd,
    };
    const openCollapsedCall = () => {
        setCollapsedCall(true);
        openSidePanel({
            sidePanelId: 'Voip',
            options: {
                view: 'voip',
            },
        });
    };
    const closeCall = () => {
        setCollapsedCall(false);
        onClose();
    };
    const closeCollapsedCall = () => {
        setCollapsedCall(false);
        openSidePanel({
            sidePanelId: 'Voip',
            options: {
                view: 'voip',
            },
        });
    };
    const handleOnClose = () => {
        onClose(!!isWithCallScreen);
        if (!isWithCallScreen) {
            setVoipScreen(voipScreens.WITHOUT_CALL);
        }
    };
    useEffect(() => () => {
        phone.deinit();
    }, [phone]);
    if (collapsedDisable && open) {
        return (_jsx(CollapsedDisabledLayout, { onClose: onClose, background: background, children: children }));
    }
    if (isWebview) {
        return _jsx(WebviewLayout, { children: children });
    }
    return (_jsxs(React.Fragment, { children: [collapsedCall && open && (_jsx(CollapsedVoip, { closeCall: closeCall, closeCollapsedCall: closeCollapsedCall })), (!collapsedCall || displayPanel === Page.OtherContacts) && (_jsx(SidePanel, { open: open, onClose: isWithCallScreen && displayPanel !== Page.OtherContacts
                    ? openCollapsedCall
                    : handleOnClose, dataTestId: 'voip-side-panel', nativeScrollbar: true, className: cn(styles[background], styles[theme]), transitionProps: sidePanelTransitionProps, children: children })), _jsx("audio", { ref: remoteAudioVideo, autoPlay: true })] }));
};
